export default {"src":"/_next/static/media/map-pin-footer.c59a6600.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};